import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_8: FaireProductEntity = {
  token: "atc_refined_moma_8",
  type: "product",
  name: "Artistic Drinkware Collection",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/553d4dc7524af372ed1f4074d25c5f202a7088ee4bf8967d4b01716a893eb119.webp",
  priceDollars: 28,
  msrpDollars: 48,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
